export default __webpack_public_path__ + "39bd303fbf945408f7f6e585bc086ee4.ttf";